var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDental(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.76923 5C10.0615 5 10.9231 6 12 6C13.0769 6 13.9385 5 15.2308 5C16.8462 5 19 6 19 8.5C19 11 16.8462 13 16.8462 14.5C16.8462 16 16.8462 20 15.2308 20C13.6154 20 13.0769 15 12 15C10.9231 15 10.3846 20 8.76923 20C7.15385 20 7.15385 16 7.15385 14.5C7.15385 13 5 11 5 8.5C5 6 7.15385 5 8.76923 5Z",
    stroke: "white",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDental);
export default __webpack_public_path__ + "static/media/Dental.13db14e4f23037db20133bd7e0df85fb.svg";
export { ForwardRef as ReactComponent };